import {
  DataField,
  ReviewStageDataFieldTypeEnum,
  TextDataField,
} from 'components/FormBuilder/schemas';

export function isTextDataField(
  dataField: DataField,
): dataField is TextDataField {
  return dataField.type === ReviewStageDataFieldTypeEnum.text_field;
}
